/**
 * The screen that did not exist, because Cloudflare Access never let you reach the
 * app unauthenticated — there was nothing to render for a signed-out person.
 *
 * Deliberately plain. It is a door, and the only thing behind it is one household's
 * budget, so there is nothing to explain, market, or offer: no sign-up link, because
 * membership is an invitation in Kinde plus a row in `members`, and no password field,
 * because this app never sees one.
 */

import { useAuth } from '../lib/auth.tsx'

export function SignIn() {
  const { signIn, error } = useAuth()

  return (
    <main className="flex min-h-dvh items-center justify-center px-6">
      <div className="flex w-full max-w-[360px] flex-col gap-6 text-center">
        <div className="flex flex-col gap-2">
          <h1 className="m-0 font-display text-[40px] leading-none">Kete</h1>
          <p className="m-0 text-[14px] leading-[1.55] text-muted">
            Your budget, for the two of you.
          </p>
        </div>

        <button
          type="button"
          onClick={signIn}
          className="rounded-full bg-cta px-5 py-3 text-[14px] font-medium text-cta-fg transition-colors hover:bg-cta-hover"
        >
          Sign in
        </button>

        {/*
          Kinde's own words, not a rewrite of them. A wrong redirect URI and a revoked
          account fail differently, and paraphrasing both as "sign-in failed" is what
          turns a two-minute configuration fix into an afternoon.
        */}
        {error && (
          <p className="m-0 rounded-[10px] bg-blush-soft/60 px-3 py-2 text-[12.5px] leading-[1.5] text-ink-dim">
            {error}
          </p>
        )}
      </div>
    </main>
  )
}
